module.exports = __webpack_public_path__ + "img/10.4d89b9c6.png";